import React from 'react'
import "../components/Footer.scss"

class Footer extends React.Component {
  render() {
    return (
      
      <footer className="footer">
      <div className="footer">
  <div id="button"></div>
<div id="container">
<div id="cont">
<div className="social-link" className="footer_center">
	   <h3>Contact us to Book a Room!</h3>
     <a className="social-link" href="https://fowsinur.com/#Contact" target="_blank"><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "#104a2a"}}className="fa fa-phone"></i></a>
     <a className="social-link" href="mailto:fowsinur@gmail.com" target="_blank" ><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "#057a96"}} className="fa fa-envelope"></i></a>
     <a className="social-link" href="https://twitter.com/" target="_blank"><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "blue"}} className="fa fa-twitter"></i></a>
     <a className="social-link" href="https://www.facebook.com/" target="_blank"><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "#347ff7"}} className="fa fa-facebook"></i></a>
     <a className="social-link" href="https://www.instagram.com/?hl=en" target="_blank"><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "#2d0869"}}className="fa fa-instagram"></i></a>
     <a className="social-link" href="https://www.linkedin.com/" target="_blank"><i style={{marginTop: -300, paddingRight: 20, fontSize: 50, color: "#46285e"}}className="fa fa-linkedin"></i></a>
     
  
    <div>
      
      </div> 
  
     
</div>
</div>
</div>
</div>
    </footer>
    );
  }
}

export default Footer